import React from 'react';
import classnames from 'classnames';
import { PapiDeviation } from '@wix/da-papi-types';
import Heading from '@wix/da-a11y/pkg/components/headings/Heading';
import DeviationLink from '../../../../Duperbrowse/DeviationLink';
import { getDeviationTitle } from '../../../_helpers';

import s from './FeedCardTitle.scss';

export interface Props {
  deviation: PapiDeviation;
  className?: string;
  /** should duperbrowse try to restore the scroll location when returning from the title link */
  disableScrollRestoration?: boolean;
}

const FeedCardTitle: React.FC<Props> = ({
  deviation,
  className,
  disableScrollRestoration = true,
}) => {
  return (
    <Heading className={classnames(s['title'], className)}>
      <DeviationLink deviation={deviation} disableScrollRestoration={disableScrollRestoration}>
        {getDeviationTitle(deviation)}
      </DeviationLink>
    </Heading>
  );
};
FeedCardTitle.displayName = 'FeedCardTitle';

export default FeedCardTitle;
